export default __webpack_public_path__ + "static/media/eventCrew.9f5e5848.svg";